import React, { useState, useEffect } from "react";
import { TextField, Box } from "@mui/material";
import CustomTable from "../../core/custom-table";

const EditableTable = ({ listData, tableData, setTableData }) => {
  const handleFieldChange = (data, field, value) => {
    setTableData((prevVal) => {
      return prevVal.map((ele) => {
        if (ele.id === data.id) {
          return {
            ...ele,
            [field]: value,
          };
        }
        return {
          ...ele,
        };
      });
    });
  };

  const headers = () => [
    {
      id: "listNumber",
      label: "List Number",
      render: (data) => (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data.listNumber}
        </Box>
      ),
    },
    {
      id: "alphaStageDate",
      label: "Alpha Stage Date",
      render: (data) => (
        <TextField
          value={data.alphaStageDate}
          onChange={(e) =>
            handleFieldChange(data, "alphaStageDate", e.target.value)
          }
          variant="outlined"
          size="small"
          type="date"
          fullWidth
        />
      ),
    },
    {
      id: "betaStageDate",
      label: "Beta Stage Date",
      render: (data) => (
        <TextField
          value={data.betaStageDate}
          onChange={(e) =>
            handleFieldChange(data, "betaStageDate", e.target.value)
          }
          variant="outlined"
          size="small"
          type="date"
          fullWidth
        />
      ),
    },
    {
      id: "wsmRediness",
      label: "WSM Readiness",
      render: (data) => (
        <TextField
          value={data.wsmRediness}
          onChange={(e) =>
            handleFieldChange(data, "wsmRediness", e.target.value)
          }
          variant="outlined"
          size="small"
          fullWidth
        />
      ),
    },
    {
      id: "wsmRedinessDate",
      label: "WSM Readiness Date",
      render: (data) => (
        <TextField
          value={data.wsmRedinessDate}
          onChange={(e) =>
            handleFieldChange(data, "wsmRedinessDate", e.target.value)
          }
          variant="outlined"
          size="small"
          type="date"
          fullWidth
        />
      ),
    },
    {
      id: "partsCatalogueRediness",
      label: "Parts Catalogue Readiness",
      render: (data) => (
        <TextField
          value={data.partsCatalogueRediness}
          onChange={(e) =>
            handleFieldChange(data, "partsCatalogueRediness", e.target.value)
          }
          variant="outlined"
          size="small"
          fullWidth
        />
      ),
    },
    {
      id: "partsCatalogueRedinessDate",
      label: "Parts Catalogue Rediness Date",
      render: (data) => (
        <TextField
          value={data.partsCatalogueRedinessDate}
          onChange={(e) =>
            handleFieldChange(
              data,
              "partsCatalogueRedinessDate",
              e.target.value
            )
          }
          variant="outlined"
          size="small"
          type="date"
          fullWidth
        />
      ),
    },
    {
      id: "recommendedPartsListRediness",
      label: "Recommended Parts List",
      render: (data) => (
        <TextField
          value={data.recommendedPartsListRediness}
          onChange={(e) =>
            handleFieldChange(
              data,
              "recommendedPartsListRediness",
              e.target.value
            )
          }
          variant="outlined"
          size="small"
          fullWidth
        />
      ),
    },
    {
      id: "remarks",
      label: "Remarks",
      render: (data) => (
        <TextField
          value={data.remarks}
          onChange={(e) => handleFieldChange(data, "remarks", e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
        />
      ),
    },
  ];

  useEffect(() => {
    setTableData((prevData) =>
      listData.map((listNumber, index) => {
        const existing = prevData.find((row) => row.listNumber === listNumber);
        const data = (existing && {
          ...existing,
          alphaStageDate: existing?.alphaStageDate?.split("T")[0] || "",
          betaStageDate: existing?.betaStageDate?.split("T")[0] || "",
          wsmRedinessDate: existing?.wsmRedinessDate?.split("T")[0] || "",
          partsCatalogueRedinessDate:
            existing?.partsCatalogueRedinessDate?.split("T")[0] || "",
          id: index + 1,
        }) || {
          id: index + 1,
          listNumber,
          alphaStageDate: "",
          betaStageDate: "",
          wsmRediness: "",
          partsCatalogueRediness: "",
          recommendedPartsListRediness: "",
          wsmRedinessDate: "",
          partsCatalogueRedinessDate: "",
          remarks: "",
        };
        delete data?._id;
        return data;
      })
    );
  }, [listData, setTableData]);

  return (
    <CustomTable header={headers()} data={tableData} enableSorting={false} />
  );
};

export default EditableTable;
